export const SCREENS = {
  WELCOME: "/welcome",
  OCR: "/ocr",
  CUSTOMER: "/customer",
  ATTACHMENTS: "/attachments",
  RECAPITULATION: "/recapitulation",
  AGREEMENTS: "/agreements",
  SMS_CODE: "/sms-code",
  VEHICLE: "/vehicle",
  VIEW: "/view",
  SIGNATURE: "/signature",
  SIGNATURE_ON_PHONE: "/signature-on-phone",
  THANK_YOU: "/thank-you",
  IDENTIFICATION: "/identification",
  PRODUCTION_POINT: "/production-point",
  PAYMENTS: "/payments",
  SUPPLY_POINT: "/supply-point",
  SUPPLY_POINT_CONFIRM: "/supply-point-confirm",
  SUPPLIER: "/supplier",
  TARIFF: "/tariff",
  GUIDE: "/guide",
  ADD_INFORMATION: "/add-information",
  NEW_CUSTOMER: "/new-customer",
  CLAIM_PAYMENT: "/claim-payment",
  CANCEL: "/cancel",
  DOWNLOAD_DOCUMENTS: "/download-documents",
  NEW_CUSTOMER_TRANSFER: "/new-customer/transfer",
  NEW_CUSTOMER_WELCOME: "/new-customer/welcome",
  NEW_CUSTOMER_THANK_YOU: "/new-customer/thank-you",
  REQUEST_NEW_WELCOME: "/request/new/welcome",
  PREVIOUS_CUSTOMER: "/previous-customer",
  ZSP_KO: "/zsp_ko",
};
